export const wizardQuestionStepKeys = {
  foodServiceBulkItems: 'foodService',
  alcoholicBeverages: 'alcoholic',
  sellableInnerPack: 'retailInnerPack',
  displayShippers: 'storeDisplay',
  shelfDisplayBoxTray: 'merchandisedInTray',
  multipacks: 'multipack',
  perishable: 'perishable',
};
